import { render, staticRenderFns } from "./TaskMetadataArgLabel.vue?vue&type=template&id=8045936e&scoped=true&"
import script from "./TaskMetadataArgLabel.vue?vue&type=script&lang=ts&"
export * from "./TaskMetadataArgLabel.vue?vue&type=script&lang=ts&"
import style0 from "./TaskMetadataArgLabel.vue?vue&type=style&index=0&id=8045936e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8045936e",
  null
  
)

export default component.exports